/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { UserTask } from '../models/user-task';
@Injectable({
  providedIn: 'root',
})
class UserTasksService extends __BaseService {
  static readonly UserTasksGetAllPath = '/user-tasks';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Returns all tasks of all vaults for the current user
   * @param Authorization Bearer JSON Web Token
   * @return OK
   */
  UserTasksGetAllResponse(Authorization: string): __Observable<__StrictHttpResponse<Array<UserTask>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (Authorization != null) __headers = __headers.set('Authorization', Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/user-tasks`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<UserTask>>;
      })
    );
  }
  /**
   * Returns all tasks of all vaults for the current user
   * @param Authorization Bearer JSON Web Token
   * @return OK
   */
  UserTasksGetAll(Authorization: string): __Observable<Array<UserTask>> {
    return this.UserTasksGetAllResponse(Authorization).pipe(
      __map(_r => _r.body as Array<UserTask>)
    );
  }
}

namespace UserTasksService {
}

export { UserTasksService }